import { CognitoUserPool } from "amazon-cognito-identity-js";
import { AWSCognitoPoolData } from "../config";

export default new CognitoUserPool(AWSCognitoPoolData);
